import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons solid "pencil-square" - the Card list item's "Settings" action pill icon (Figma).
// currentColor, not the pasted asset's hardcoded fill="#010F55", so it can adopt the pill
// button's own navy text color rather than being locked to one shade.
const PencilSquare = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M14.4874 1.51256C13.804 0.829146 12.696 0.829146 12.0126 1.51256L11.2411 2.28399L13.716 4.75887L14.4874 3.98744C15.1709 3.30402 15.1709 2.19598 14.4874 1.51256Z"
      fill="currentColor"
    />
    <path
      d="M13.0089 5.46598L10.534 2.9911L4.93346 8.59166C4.52227 9.00286 4.22001 9.51002 4.054 10.0673L3.52081 11.8573C3.4684 12.0332 3.51663 12.2237 3.64645 12.3535C3.77627 12.4834 3.96679 12.5316 4.14275 12.4792L5.93267 11.946C6.48999 11.78 6.99715 11.4777 7.40834 11.0665L13.0089 5.46598Z"
      fill="currentColor"
    />
    <path
      d="M3.5 3.49999C2.39543 3.49999 1.5 4.39542 1.5 5.49999V12.5C1.5 13.6046 2.39543 14.5 3.5 14.5H10.5C11.6046 14.5 12.5 13.6046 12.5 12.5V9C12.5 8.72385 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.72385 11.5 9V12.5C11.5 13.0523 11.0523 13.5 10.5 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5V5.49999C2.5 4.94771 2.94772 4.49999 3.5 4.49999H7C7.27614 4.49999 7.5 4.27614 7.5 3.99999C7.5 3.72385 7.27614 3.49999 7 3.49999H3.5Z"
      fill="currentColor"
    />
  </svg>
);

export default PencilSquare;
